<template>
    <div className="home_div " v-loading.lock="fullscreenLoading" element-loading-text="地图数据加载中">
        <div style="height: 30px">
            <el-button type="primary">
                项目名称:{{ project.projectName }}
            </el-button>

            <el-button type="primary" style="margin-left: 16px;" @click="open_drawer">
                设备列表
            </el-button>
            <el-button type="success" style="margin-left: 16px;" @click="add_device"
                       :disabled="dialog_addDevice_Visible">
                添加设备
            </el-button>
            <el-button type="warning" @click="pageReflash">刷新</el-button>

            <div style="float: right">
                <el-tag size="medium" effect="dark" style="margin-right: 10px">设备总数:{{
                        total_num
                    }}
                </el-tag>
                <el-tag size="medium" effect="dark" style="margin-right: 10px" type="success">在线数:{{
                        online_num
                    }}
                </el-tag>
                <el-tag size="medium" effect="dark" style="margin-right: 10px" type="warning">
                    亮灯数:{{
                        ligth_on_num
                    }}
                </el-tag>
            </div>
        </div>

        <div class="info2" id="text2" v-if="dialog_addDevice_Visible">
            <el-form label-width="80px" style="margin-top: 20px" size="small" :model="deviceForm" :rules="rules"
                     ref="deviceForm">

                <el-form-item label="设备类型" prop="type">
                    <el-radio-group v-model="deviceForm.type" @change="radio_change()">
                        <el-radio label="单灯" value="light"></el-radio>
                        <el-radio label="多头灯" value="multi"></el-radio>
                        <el-radio label="漏保开关" value="switch"></el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="设备ID" prop="id">
                    <el-input autocomplete="off" v-model="deviceForm.id"></el-input>
                </el-form-item>

                <el-form-item label="设备昵称" prop="nickname">
                    <el-input autocomplete="off" v-model="deviceForm.nickname"></el-input>
                </el-form-item>

                <el-form-item label="上级漏保" v-if="deviceForm.type=='单灯' || deviceForm.type=='多头灯'">
                    <el-select v-model="deviceForm.switch" placeholder="选择漏保开关,非必选" clearable>

                        <el-option
                            v-for="item in switchList"
                            :key="item.id"
                            :label="item.nickName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer" style="margin-left: 100px">
               <el-button type="primary" @click="add_device_confirm">确定</el-button>
                <el-button type="danger" @click="close_device_confirm">关闭</el-button>
            </span>
        </div>

        <div class="info" id="text" v-if="show_light_info">
            <!--            请用鼠标拖拽地图试试
                        {{scale}}-->
            <!--            <el-card class="box-card">
                            <div v-for="o in 4" :key="o" class="text item">
                                {{'列表内容 ' + o }}
                            </div>
                        </el-card>-->
            <el-descriptions direction="vertical" :column="4" border :contentStyle="{'text-align': 'center'}"
                             :labelStyle="{'text-align': 'center'}">
                <el-descriptions-item label="设备ID">{{ device_info.device.id }}</el-descriptions-item>
                <el-descriptions-item label="设备别名">{{ device_info.device.nickName }}</el-descriptions-item>
                <el-descriptions-item label="最后通讯时间" :span="2">{{ device_info.time }}</el-descriptions-item>


                <el-descriptions-item label="信号强度">
                    {{ device_info.param == 'none' ? '未知' : device_info.param.dbm + 'dbm' }}
                </el-descriptions-item>
                <el-descriptions-item label="硬件版本">
                    {{ device_info.param == 'none' ? '未知' : 'v' + device_info.param.ver }}
                </el-descriptions-item>
                <el-descriptions-item label="状态">{{ device_info.device.online ? '在线' : '离线' }}</el-descriptions-item>

                <el-descriptions-item label="灯况"
                                      v-if="device_info.device.type=='light' ||device_info.device.type=='multi'">
                    {{ device_info.device.light_on ? '亮灯' : '灭灯' }}
                </el-descriptions-item>

                <el-descriptions-item label="开合状态" v-if="device_info.device.type=='switch' ">
                    {{ device_info.device.light_on ? '开闸' : '合闸' }}
                </el-descriptions-item>

                <el-descriptions-item label="交流电压">
                    {{ device_info.param == 'none' ? '未知' : device_info.param.acVol + 'V' }}
                </el-descriptions-item>
                <el-descriptions-item label="直流电压">
                    {{ device_info.param == 'none' ? '未知' : device_info.param.dcVol + 'V' }}
                </el-descriptions-item>
                <el-descriptions-item label="交流电流">
                    {{ device_info.param == 'none' ? '未知' : device_info.param.acCur + 'A' }}
                </el-descriptions-item>
                <el-descriptions-item label="直流电流">
                    {{ device_info.param == 'none' ? '未知' : device_info.param.dcCur + 'A' }}
                </el-descriptions-item>

                <el-descriptions-item label="功率因数">
                    {{ device_info.param == 'none' ? '未知' : device_info.param.powerFactor }}
                </el-descriptions-item>
                <el-descriptions-item label="有功功率">{{ device_info.param == 'none' ? '未知' : device_info.param.power }}
                </el-descriptions-item>
                <el-descriptions-item label="总电量">
                    {{ device_info.param == 'none' ? '未知' : device_info.param.quantity + 'kwh' }}
                </el-descriptions-item>
                <el-descriptions-item label="设备类型">{{ getTypeName(device_info.device.type) }}</el-descriptions-item>

                <el-descriptions-item label="温度">
                    {{ device_info.param == 'none' ? '未知' : device_info.param.temper + '度' }}
                </el-descriptions-item>
                <el-descriptions-item label="运行天数">
                    {{ device_info.DiffDay + '天' }}
                </el-descriptions-item>

                <el-descriptions-item label="漏保开关" :span="2" v-if="device_info.device.type!='switch' ">
                    <el-dropdown split-button type="primary" trigger="click"  @command="handleCommand">
                        {{ switchName }}
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item  :command="beforeHandleCommand(index,device_info.index)" v-for="(item,index) in switchList" :key="index">{{
                                    item.nickName
                                }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-popconfirm
                        class="ml-5"
                        placement="top-start"
                        confirm-button-text='确定'
                        cancel-button-text='我再想想'
                        icon="el-icon-info"
                        icon-color="red"
                        title="是否删除绑定的漏保开关？"
                        @confirm="del_banding_switch(device_info.index)"
                    >
                        <el-link type="danger" slot="reference" v-if="device_info.device.switchId!=null">删除</el-link>
                    </el-popconfirm>
                </el-descriptions-item>



                <el-descriptions-item label="灯头开关控制" :span="4" v-if="device_info.device.type=='multi' ">
                    灯头1
                    <el-switch
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        v-model="light_1"
                        :active-value="1"
                        :inactive-value="0"
                        @change="Switch_multi($event,device_info)"
                    />
                    灯头2
                    <el-switch
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        v-model="light_2"
                        :active-value="2"
                        :inactive-value="0"
                        @change="Switch_multi($event,device_info)"
                    />
                    灯头3
                    <el-switch
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        v-model=light_3
                        :active-value="4"
                        :inactive-value="0"
                        @change="Switch_multi($event,device_info)"
                    />
                    灯头4
                    <el-switch
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        v-model="light_4"
                        :active-value="8"
                        :inactive-value="0"
                        @change="Switch_multi($event,device_info)"
                    />
                </el-descriptions-item>
            </el-descriptions>

            <el-row style="margin-top: 10px" v-if="device_info.device.type=='switch'">
                <el-button size="mini" round type="success" :disabled="device_info.device.light_on"
                           @click="switch_single(device_info.device.id,device_info.device.type,true,device_info.index)">
                    开闸
                </el-button>
                <el-button size="mini" round type="danger" :disabled="!device_info.device.light_on"
                           @click="switch_single(device_info.device.id,device_info.device.type,false,device_info.index)">
                    合闸
                </el-button>
                <el-button size="mini" round type="warning" @click="reboot(device_info.device.id)">重启</el-button>
                <!--                <el-button size="mini" round type="danger" @click="del_device(device_info.device,2)">删除</el-button>-->
            </el-row>

            <el-row style="margin-top: 10px" v-if="device_info.device.type!='switch'">
                <el-button size="mini" round type="success" :disabled="device_info.device.light_on"
                           @click="switch_single(device_info.device.id,device_info.device.type,true,device_info.index)">
                    开灯
                </el-button>
                <el-button size="mini" round type="danger" :disabled="!device_info.device.light_on"
                           @click="switch_single(device_info.device.id,device_info.device.type,false,device_info.index)">
                    关灯
                </el-button>
                <el-button size="mini" round type="primary" @click="openSlider(device_info.device.id)">调光</el-button>
                <el-button size="mini" round type="warning" @click="reboot(device_info.device.id)">重启</el-button>
                <!--                <el-button size="mini" round type="danger" @click="del_device(device_info.device,2)">删除</el-button>-->
            </el-row>
        </div>

        <div id="container" style="height: calc(100vh - 147px);margin-top: 10px "></div>

        <el-drawer style="z-index: 999;height: calc(100vh)"
                   title="设备列表" :with-header="false"
                   :visible.sync="drawer"
                   :direction="direction" size="70%"
                   :before-close="handleClose">

            <div style="height: 30px;margin-top: 20px;margin-left: 20px">
                <!--                <el-button class="ml-5" type="primary" @click="reflash" style="margin-left: 16px;">刷新</el-button>-->
                <el-button type="success" @click="switch_pathc_light(1)">开启</el-button>
                <el-button type="danger" @click="switch_pathc_light(0)">关闭</el-button>

            </div>
            <!--            :cell-style="cellStyle"   :data="tableData.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"-->
            <el-table
                :data="tableData.filter(data => !search || data.deviceId.toLowerCase().includes(search.toLowerCase()))"
                border :header-cell-class-name="'headerBg'" ref="multipleTable" stripe
                v-loading="drawerLoding"
                @selection-change="handleSelectionChange" :sortable="false"
                style="margin-top: 10px;" height="calc(100vh - 100px)">
                <el-table-column type="selection" width="55" fixed></el-table-column>
                <el-table-column prop="index" label="序号" width="50" align="center" fixed="left"></el-table-column>

                <el-table-column prop="deviceId" label="设备id" align="center" width="120" fixed="left"></el-table-column>
                <el-table-column prop="type" label="类型" align="center" width="120">

                </el-table-column>

                <el-table-column prop="nickName" label="昵称别名" align="center" width="120"></el-table-column>
                <el-table-column prop="latlng" label="位置" align="center" width="160"></el-table-column>
                <el-table-column prop="online" label="网络" align="center" width="70"
                                 :filters="[{ text: '在线', value: '在线' }, { text: '离线', value: '离线' }]"
                                 :filter-method="filterTag">
                    <template slot-scope="scope">
                        <el-tag
                            :type="scope.row.online === '在线' ? 'success' : 'danger'"
                            disable-transitions>{{ scope.row.online }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="light_on" label="状态" align="center" width="70"
                                 :filters="[{ text: '开启', value: '开启' }, { text: '关闭', value: '关闭' }]"
                                 :filter-method="filterTag2">
                    <template slot-scope="scope">
                        <el-tag
                            :type="scope.row.light_on === '开启' ? 'success' : 'danger'"
                            disable-transitions>{{ scope.row.light_on }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="planstate" label="计划状态" align="center" width="80">
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.planstate"

                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            @change="changeDevicePlan($event,scope.row)"
                        />
                    </template>

                </el-table-column>
                <el-table-column label="操作" align="center" min-width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input
                            v-model="search"
                            size="mini"
                            clearable
                            placeholder="请输入设备ID进行搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <el-button type="primary" @click="location(scope.row,scope.row.index-1)">定位</el-button>
                        <el-button type="primary" @click="edit_name(scope.row)">改名</el-button>
                        <!--            <el-button type="success" @click="handleEdit(scope.row)">编辑 <i class="el-icon-edit"></i></el-button>-->
                        <el-popconfirm
                            class="ml-5"
                            confirm-button-text='确定'
                            cancel-button-text='我再想想'
                            icon="el-icon-info"
                            icon-color="red"
                            title="是否删除该设备？"
                            @confirm="del_device(scope.row)"
                        >
                            <el-button type="danger" slot="reference">删除
                            </el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </el-drawer>

        <el-dialog title="设备调光" :visible.sync="dialog_setBrightness_Visible" width="30%">
            <div class="block">
                <span class="demonstration">灯光亮度:{{ brightness }}</span>
                <el-slider v-model="brightness" :show-tooltip="false"></el-slider>
            </div>
            <span slot="footer" class="dialog-footer">

                 <el-button type="primary" @click="setBrightness()" size="medium">确 定</el-button>
               </span>

        </el-dialog>

        <!--        <el-dialog title="添加设备" :visible.sync="dialog_addDevice_Visible" width="30%" center >
                    <el-form label-width="80px" size="small" :model="device" :rules="rules" ref="deviceForm">
                        <el-form-item label="设备ID" prop="id">
                            <el-input autocomplete="off" v-model="device.id"></el-input>
                        </el-form-item>
                        <el-form-item label="经纬度" prop="latlng">
                            <el-input autocomplete="off" v-model="device.latlng"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialog_addDevice_Visible = false">取 消</el-button>
                        <el-button type="primary" @click="dialog_addDevice_Visible = false">确 定</el-button>
                    </div>
                </el-dialog>-->
    </div>
</template>
<script>
import AMapLoader from '@amap/amap-jsapi-loader';
import MarkIcon_lighton from '@/assets/icon/lamp_lighton.png'
import MarkIcon_lightoff from '@/assets/icon/lamp_ligthoff.png'
import MarkIcon_offline from '@/assets/icon/lamp_offline.png'

import MarkIcon_switch_on from '@/assets/icon/switch_on.png'
import MarkIcon_switch_off from '@/assets/icon/switch_off.png'
import MarkIcon_switch_offline from '@/assets/icon/switch_offline.png'

import MarkIcon_multi_on from '@/assets/icon/开灯.png'
import MarkIcon_multi_off from '@/assets/icon/关灯.png'
import MarkIcon_multi_offline from '@/assets/icon/灯离线.png'
import {Loading} from 'element-ui';
import Vue from "vue";

window._AMapSecurityConfig = {
    securityJsCode: 'f924dc66c45f8b2ae5c89b10fd333a63'
}

export default {
    name: "Mapview",
    data() {
        return {
            visible: false,
            fullscreenLoading: true,
            project: '',
            drawer: false,
            drawerLoding: true,
            loadingInstance: null,
            direction: 'rtl',
            total_num: 0,
            online_num: 0,
            ligth_on_num: 0,
            markers: [],
            points: [],
            map: null,
            geolocation: null,
            cluster: null,
            zoom: 15,
            scale: '',
            tableData: [],
            dialog_setBrightness_Visible: false,
            brightness: 0,
            multipleSelection: [],
            center: [116.397557, 39.907897],
            device_info: {
                device: '',
                param: ''

            },
            rules: {
                id: [
                    {required: true, message: '请输入设备id', trigger: 'blur'},
                    {min: 4, max: 30, message: '长度在 4 到 30 个字符', trigger: 'blur'}
                ],
                type: [
                    {required: true, message: '请选择设备类型', trigger: 'change'}
                ],
                /*  latlng: [
                      {required: true, message: '请输入经纬度', trigger: 'blur'}
                  ],*/
            },

            device_id: '',
            show_light_info: false,
            dialog_addDevice_Visible: false,
            centerMarker: '',
            deviceForm: {},
            search: '',
            switchList: '',
            select_value: '',
            light_1: 0,
            light_2: 0,
            light_3: 0,
            light_4: 0,
            switchName: '添加',
        }
    },
    created() {
        let p_data = JSON.parse(sessionStorage.getItem('project'))

        this.project = p_data

    },
    mounted() {
        this.initAMap();

    },
    methods: {
        initAMap() {
            AMapLoader.load({
                key: '9b16e0ac0b56127f48f850a970ad12ff',
                version: "2.0",
                plugins: ['AMap.ToolBar', 'AMap.Driving', 'AMap.MarkerCluster', 'AMap.MapType', 'AMap.Geolocation'],
                AMapUI: {
                    version: "1.1",
                    plugins: [],
                },
                Loca: {
                    version: "2.0"
                },
            }).then((AMap) => {
                this.map = new AMap.Map("container", {
                    //viewMode: "3D",
                    zoom: this.zoom,
                    zooms: [4, 20],
                    center: this.center,
                });
                /* this.map.setFeatures(['road','bg']); // 多个种类要素显示*/
                this.load()
                this.get_switch()
                /*    this.geolocation = new AMap.Geolocation({
                        enableHighAccuracy: true,//是否使用高精度定位，默认:true
                        timeout: 10000,          //超过10秒后停止定位，默认：5s
                        position:'LB',    //定位按钮的停靠位置
                        offset: [10, 20], //定位按钮与设置的停靠位置的偏移量，默认：[10, 20]
                        zoomToAccuracy: true,   //定位成功后是否自动调整地图视野到定位点
                    });
                    this.map.addControl(this.geolocation);*/
                /* geolocation.getCurrentPosition(function(status,result){
                     console.log(status)
                     this.$message.error("定位失败")
                     console.log(result)
                     if(status=='complete'){
                         //onComplete(result)
                         this.$message.success("定位成功")
                         this.$message.success("定位成功")
                     }else{
                         this.$message.error("定位失败")

                         //onError(result)
                     }
                 });*/

                /* this.map.on("zoomchange", () => {
                     // console.log(this.map.getZoom())
                     this.scale = this.map.getZoom()
                 })*/
                /* this.map.on("moveend", () => {
                     //console.log(this.map.getCenter().lat)
                     //console.log(this.map.getCenter().lng)
                     this.center = [this.map.getCenter().lng,this.map.getCenter().lat]
                     /!*if(this.centerMarker!=''){
                         this.centerMarker.setPosition(this.center)
                     }*!/
                 })*/

                this.map.on("click", () => {
                    // console.log(this.map.getZoom())
                    //this.scale = this.map.getZoom()
                    this.show_light_info = false
                    this.rest_marker()//重置marker状态
                })
            }).catch(e => {
                console.log(e);
            })

        },

        /**
         * 重置标记状态
         */
        rest_marker() {
            for (let i = 0; i < this.markers.length; i++) {
                this.markers[i].setLabel({
                    content: null, //清除文本标注内容
                });
                this.markers[i].setDraggable(false) //清除拖动
            }

        },
        cellStyle(row) {
            if (row.columnIndex == 5) {
                if (row.row.online == "在线") {
                    return 'color:#00c000'
                } else {
                    return 'color:#ff0400'
                }
            }
            if (row.columnIndex == 6) {
                if (row.row.light_on == "开启") {
                    return 'color:#00c000'
                } else {
                    return 'color:#ff0400'
                }
            }

        },
        filterTag(value, row) {
            //console.log(value,row)
            return row.online === value;
        },
        filterTag2(value, row) {
            //console.log(value,row)
            return row.light_on === value;
        },
        /**
         * 加载数据
         * @returns {Promise<void>}
         */
        async load() {
            this.markers = []
            this.tableData = []
            if (this.map != null) {
                this.map.clearMap()
            }
            let data = await this.getData();
            let device = data.device
            this.total_num = device.length
            this.online_num = data.online
            this.ligth_on_num = data.lightOn

            for (const v in device) {
                let table_data = {}
                table_data.index = parseInt(v) + 1
                table_data.deviceId = device[v].id
                table_data.nickName = device[v].nickName
                table_data.online = device[v].online ? "在线" : "离线"
                table_data.type = device[v].type
                table_data.light_on = device[v].light_on ? "开启" : "关闭"
                table_data.latlng = device[v].lat + "," + device[v].lng
                table_data.planstate = device[v].planState
                this.tableData.push(table_data)
                let mark_img = ''
                if (device[v].online == true) {
                    if (device[v].light_on == true) {
                        if (device[v].type == 'light') {
                            mark_img = MarkIcon_lighton
                        } else if (device[v].type == 'switch') {
                            mark_img = MarkIcon_switch_on
                        } else if (device[v].type == 'multi') {
                            mark_img = MarkIcon_multi_on
                        }

                    } else {
                        if (device[v].type == 'light') {
                            mark_img = MarkIcon_lightoff
                        } else if (device[v].type == 'switch') {
                            mark_img = MarkIcon_switch_off
                        } else if (device[v].type == 'multi') {
                            mark_img = MarkIcon_multi_off
                        }

                    }
                } else {
                    if (device[v].type == 'light') {
                        mark_img = MarkIcon_offline
                    } else if (device[v].type == 'switch') {
                        mark_img = MarkIcon_switch_offline
                    } else if (device[v].type == 'multi') {
                        mark_img = MarkIcon_multi_offline
                    }

                }
                let startIcon = new AMap.Icon({
                    // 图标尺寸
                    size: new AMap.Size(30, 30), // 图标尺寸
                    imageSize: new AMap.Size(30, 30), // 图标尺寸
                    image: mark_img,
                });
                this.points.push({
                    lnglat: [device[v].lng, device[v].lat]
                });
                let marker = new AMap.Marker({
                    map: this.map,
                    icon: startIcon,
                    offset: new AMap.Pixel(-15, -30),
                    position: [device[v].lng, device[v].lat],
                    title: device[v].id,
                });

                this.markers.push(marker)

                marker.on("click", () => {
                    let point = {latlng: device[v].lat + "," + device[v].lng, deviceId: device[v].id}
                    this.location(point, v)
                })

                let orgin
                marker.on("dragstart", (e) => {
                    orgin = this.markers[v].getPosition()
                })

                marker.on("dragend", (e) => {
                    this.$confirm('是否修改设备位置?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.request.get("/devices/updatePosition", {
                            params: {
                                id: device[v].id,
                                lat: e.lnglat.lat,
                                lng: e.lnglat.lng
                            }
                        }).then(res => {
                            console.log(res)
                            if (res.code === '200') {
                                this.$message.success("修改成功")
                                this.markers[v].setPosition(new AMap.LngLat(e.lnglat.lng, e.lnglat.lat))//修改标志的经纬度
                                // this.tableData[v].latlng = e.lnglat.lat+","+e.lnglat.lng
                            } else {
                                this.$message.error("修改失败")
                            }
                        })
                    }).catch(() => {
                        console.log(this.markers[v].getPosition())
                        //this.markers[v].setPosition(new AMap.LngLat(this.markers[v].getPosition().lng, this.markers[v].getPosition().lat))
                        this.markers[v].setPosition([orgin.lng, orgin.lat])
                    });
                })
            }

            //console.log(this.points)
            //this.cluster = new AMap.MarkerCluster(this.map, this.points, {gridSize: 60});

            setTimeout(() => {
                this.map.setFitView()
            }, 500);


            this.drawerLoding = false
            this.fullscreenLoading = false

        },

        getData() {
            const res = this.request.get("/devices/findByPid", {
                params: {
                    pid: this.project.id,
                    tid: ''
                }
            }).then(res => {
                return res.data
            })
            return res
        },

        getDeviceInfo(id) {
            this.request.get("/devices/" + id, {}).then(res => {
                console.log(res)
            })

        },

        pageReflash() {
            location.reload()
        },
        changeDevicePlan(value, item) {
            this.tableData[item.index - 1].planstate = true
            this.request.get("/devices/update_planstate", {
                params: {
                    id: item.deviceId,
                    planState: value ? 1 : 0
                }
            }).then(res => {
                if (res.code == '200') {
                    this.$message.success("操作成功")
                    this.tableData[item.index - 1].planstate = value
                } else {
                    this.$message.error("操作失败")
                    this.tableData[item.index - 1].planstate = item.planstate
                }

            })
        },
        /**
         * 批量控制灯的开关
         * @param type
         */
        switch_pathc_light(type) {
            console.log(type)
            let ids = this.multipleSelection.map(v => v.deviceId)  // [{}, {}, {}] => [1,2,3]
            console.log(ids)
            console.log(ids == '')
            if (ids == '') {

                this.$message({
                    message: '请选择设备',
                    type: 'error',
                    duration: 500,
                    offset: 100
                });
            } else {
                let nos = ''
                for (const i in ids) {
                    nos = nos + ids[i] + ","
                    console.log(ids[i])
                }
                nos = nos.substr(0, nos.length - 1)
                console.log(nos)
                this.request.get("/devices/PatchSwitch", {
                    params: {
                        nos: nos,
                        state: type == 1 ? true : false
                    }

                }).then(res => {
                    if (res.code == '200') {
                        this.$message.success("指令已下发，稍后请刷新页面")
                        this.multipleSelection = []
                        this.$refs.multipleTable.clearSelection();
                    } else {
                        this.$message.error("操作失败")
                    }

                })
            }

        },
        handleSelectionChange(val) {
            console.log(val)

            this.multipleSelection = val
        },

        edit_name(row) {
            console.log(row)
            this.$prompt('请输入设备名称', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: row.nickName
            }).then(({value}) => {
                if (value == '') {
                    this.$message({
                        type: 'error',
                        message: '请输入名称'
                    });
                    return false
                }
                this.request.post("/devices", {
                    id: row.deviceId,
                    nickName: value
                }).then(res => {
                    if (res.code === '200') {
                        this.$message.success({
                                message: "修改成功",
                                duration: 1500
                            }
                        )
                        this.tableData[row.index - 1].nickName = value
                    } else {
                        this.$message.error("修改失败")
                    }
                })

            }).catch(() => {

            });

        },

        add_device() {
            this.rest_marker()
            this.map.setZoom(16)
            this.deviceForm = {}

            this.show_light_info = false
            this.dialog_addDevice_Visible = true

            this.deviceForm.latlng = this.map.getCenter().lat + "," + this.map.getCenter().lng

            this.centerMarker = new AMap.Marker({
                map: this.map,
                position: this.map.getCenter(),
                draggable: true,
            });
            this.centerMarker.setLabel({
                direction: 'top',
                offset: new AMap.Pixel(0, 0),  //设置文本标注偏移量
                content: "<div class='info'>新设备的位置,可拖动修改</div>", //设置文本标注内容
            });
            this.centerMarker.on("dragend", (e) => {
                //new AMap.LngLat(e.lnglat.lng, e.lnglat.lat)
                this.deviceForm.latlng = e.lnglat.lat + "," + e.lnglat.lng
                console.log(this.deviceForm.latlng)
            })
        },
        close_device_confirm() {
            this.dialog_addDevice_Visible = false
            this.centerMarker.setMap(null)
        },
        add_device_confirm() {
            this.$refs['deviceForm'].validate((valid) => {
                if (valid) {
                    console.log(this.deviceForm)

                    // return false
                    if (this.deviceForm.latlng == '') {
                        this.$message.error('经纬度获取失败，请重试')
                        this.dialog_addDevice_Visible = false
                        return false
                    }
                    if (this.deviceForm.type == '单灯') {
                        this.request.post("/devices/banding_wx", {
                            id: this.deviceForm.id,
                            nickName: this.deviceForm.nickname,
                            streetLightId: this.deviceForm.id,
                            latLng: this.deviceForm.latlng,
                            projectId: this.project.id,
                            switchId: this.deviceForm.switch == undefined ? '' : this.deviceForm.switch
                        }).then(res => {
                            this.dialog_addDevice_Visible = false
                            if (res.code === '200') {
                                this.$message.success("添加成功")
                                this.load()
                            } else {
                                this.$message.error(res.msg)
                            }
                        })
                    } else if (this.deviceForm.type == '多头灯') {
                        this.request.post("/devices/banding_multi_wx", {
                            id: this.deviceForm.id,
                            nickName: this.deviceForm.nickname,
                            streetLightId: this.deviceForm.id,
                            latLng: this.deviceForm.latlng,
                            projectId: this.project.id,
                            switchId: this.deviceForm.switch == undefined ? '' : this.deviceForm.switch
                        }).then(res => {
                            this.dialog_addDevice_Visible = false
                            if (res.code === '200') {
                                this.$message.success("添加成功")
                                this.load()
                            } else {
                                this.$message.error(res.msg)
                            }
                        })
                    } else {
                        this.request.post("/devices/banding_switch_wx", {
                            id: this.deviceForm.id,
                            nickName: this.deviceForm.nickname,
                            streetLightId: this.deviceForm.id,
                            latLng: this.deviceForm.latlng,
                            projectId: this.project.id
                        }).then(res => {
                            this.dialog_addDevice_Visible = false
                            if (res.code === '200') {
                                this.$message.success("添加成功")
                                this.load()
                                this.get_switch()//重新获取一次漏保开关列表
                            } else {
                                this.$message.error(res.msg)
                            }
                        })
                    }

                }
            });
        },
        /**
         * 点击右侧抽屉内表格的定位
         * @param row
         * @param index
         */
        location(row, index) {
            console.log(row)
            console.log(index)
            this.select_value = ''
            this.rest_marker()//重置marker状态
            this.show_light_info = true
            this.dialog_addDevice_Visible = false
            this.drawer = false
            this.map.setCenter([this.markers[index].getPosition().lng, this.markers[index].getPosition().lat])
            //this.map.setCenter(this.markers[index]._getPosition())
            this.map.setZoom(18)
            this.request.get("/devices/" + row.deviceId, {}).then(res => {
                console.log(res.data)
                this.device_info = res.data
                if (JSON.stringify(res.data.param) == '{}') {
                    this.device_info.param = "none"
                    this.device_info.time = '未上线'
                } else {
                    this.device_info.param = res.data.param
                    this.device_info.time = this.getdate(res.data.param.time * 1000)
                    if ((this.device_info.param.info & 1) == 1) {
                        this.light_1 = 1
                    } else {
                        this.light_1 = 0
                    }
                    if ((this.device_info.param.info & 2) == 2) {
                        this.light_2 = 2
                    } else {
                        this.light_2 = 0
                    }
                    if ((this.device_info.param.info & 4) == 4) {
                        this.light_3 = 4
                    } else {
                        this.light_3 = 0
                    }
                    if ((this.device_info.param.info & 8) == 8) {
                        this.light_4 = 8
                    } else {
                        this.light_4 = 0
                    }
                }
                this.device_info.DiffDay = this.getDiffDay(this.dateFormat("YYYY/mm/dd", new Date()), res.data.device.bandingTime.substr(0, 10))
                this.device_info.index = index
                this.markers[index].setLabel({
                    direction: 'top',
                    offset: new AMap.Pixel(0, 0),  //设置文本标注偏移量
                    content: "<div class='info'>" + res.data.device.nickName + "</div>", //设置文本标注内容
                });

                this.switchName = "添加"
                for (var i = 0; i < this.switchList.length; i++) {
                    if (this.switchList[i].id == res.data.device.switchId) {
                        console.log("有漏保：：：：：" + res.data.device.nickName)
                        this.switchName = this.switchList[i].nickName
                        //this.$forceUpdate()
                    }
                    //this.switchActionSheet.push("漏保开关" + (i + 1) + ":" + res.data[i].nickName)
                }
              /*  if (this.switchName != '点击添加') {
                    this.switchActionSheet.push("刪除綁定")
                }*/


                let mark_img = ''
                if (res.data.device.online == true) {
                    if (res.data.device.light_on == true) {

                        if (res.data.device.type == 'light') {
                            mark_img = MarkIcon_lighton
                        } else if (res.data.device.type == 'switch') {
                            mark_img = MarkIcon_switch_on
                        } else if (res.data.device.type == 'multi') {
                            mark_img = MarkIcon_multi_on
                        }
                    } else {
                        if (res.data.device.type == 'light') {
                            mark_img = MarkIcon_lightoff
                        } else if (res.data.device.type == 'switch') {
                            mark_img = MarkIcon_switch_off
                        } else if (res.data.device.type == 'multi') {
                            mark_img = MarkIcon_multi_off
                        }

                    }
                } else {
                    if (res.data.device.type == 'light') {
                        mark_img = MarkIcon_offline
                    } else if (res.data.device.type == 'switch') {
                        mark_img = MarkIcon_switch_offline
                    } else if (res.data.device.type == 'multi') {
                        mark_img = MarkIcon_multi_offline
                    }

                }
                let startIcon = new AMap.Icon({
                    // 图标尺寸
                    size: new AMap.Size(30, 30), // 图标尺寸
                    imageSize: new AMap.Size(30, 30), // 图标尺寸
                    image: mark_img,
                });
                this.markers[index].setIcon(startIcon)

                this.markers[index].setDraggable(true)

                this.$notify({
                    title: '提示',
                    message: '拖动图标可修改位置',
                });
            })

            /*this.$nextTick(() => {
                this.zoom = 18
            });*/

        },

        /**
         * 关闭右侧抽屉之前的回调
         * @param done
         */
        handleClose(done) {
            done();
        },

        /**
         * 删除绑定的漏保开关
         */
        del_banding_switch(index) {
            this.request.get("/devices/update_safeSwitch", {
                params: {
                    id: this.device_info.device.id,
                    switch_id: 0
                }
            }).then(res => {
                console.log(res)
                this.visible = false
                if (res.code === '200') {
                    this.$message.success({
                            message: "操作成功",
                            duration: 1500
                        }
                    )
                    let point = {deviceId: this.device_info.device.id}
                    this.location(point, index)
                } else {
                    this.$message.error("操作失败")
                }
            })
        },
        change_banding_switch(switch_id,index) {
            console.log(switch_id)
           /* console.log(this.select_value)
            console.log(this.switchList[this.select_value].id)*/
            this.$confirm('是否绑定这个漏保开关', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'primary'
            }).then(() => {
                this.request.get("/devices/update_safeSwitch", {
                    params: {
                        id: this.device_info.device.id,
                        switch_id: switch_id
                    }
                }).then(res => {
                    console.log(res)
                    this.visible = false
                   // this.$message(res.msg)
                    if (res.code === '200') {
                        this.$message.success({
                                message: "操作成功",
                                duration: 1500
                            }
                        )
                        let point = {deviceId: this.device_info.device.id}
                        this.location(point, index)
                    } else {
                        this.$message.error("操作失败")
                    }
                })
            }).catch(() => {

            });
        },
        open_drawer() {
            this.drawer = true
            this.show_light_info = false
            this.drawerLoding = true
            this.dialog_addDevice_Visible = false
            // this.$refs.multipleTable.clearFilter();
            this.load()
            this.search = ""
            this.rest_marker()//重置marker状态
        },

        /**
         * 删除设备
         * @param row
         */
        del_device(row) {
            console.log(row)
            let id = row.deviceId

            this.request.get("/devices/deleteBanding", {
                params: {
                    id: id
                }
            }).then(res => {
                if (res.code === '200') {
                    this.$message.success({
                            message: "删除成功",
                            //onClose: this.load,
                            duration: 1500

                        }
                    )
                    this.load()
                    this.get_switch()
                } else {
                    this.$message.error("删除失败")
                }
            })

        },
        /**
         * 打开调光滑块
         * @param id
         */
        openSlider(id) {
            this.request.get("/devices/getActualPar", {
                params: {
                    id: id
                }
            }).then(res => {
                console.log(res)
                this.device_id = id
                let data = JSON.parse(res.data)
                if (data.code == '1000') {
                    this.dialog_setBrightness_Visible = true
                } else {
                    this.$message.error(data.msg)
                }
            })

        },
        /**
         * 设置亮度
         */
        setBrightness() {
            this.request.get("/devices/setBrightness", {
                params: {
                    id: this.device_id,
                    luminance: this.brightness
                }
            }).then(res => {
                console.log(res)
                if (JSON.parse(res.data).code != '1026') {
                    this.$message.success(JSON.parse(res.data).msg)
                } else {
                    this.$message.error(JSON.parse(res.data).msg)
                }
            })
        },
        /**
         * 单个灯控制开关,弃用
         * @param id
         * @param state
         * @param index
         */
        single_swich(id, state, index) {
            console.log(id)
            console.log(state)
            this.request.get("/devices/Switch", {
                params: {
                    id: id,
                    state: state
                }
            }).then(res => {
                console.log(res)
                let that = this
                if (JSON.parse(res.data).code != '1026') {
                    this.$message.success(JSON.parse(res.data).msg)
                    let loading = this.$loading({
                        text: "请求最新灯况，请稍后",
                        lock: true,
                        duration: 3000
                    });
                    setTimeout(function () { //3秒后更新设备信息
                        let point = {deviceId: id}
                        that.location(point, index)
                        loading.close()
                    }, 3000);
                } else {
                    this.$message.error(JSON.parse(res.data).msg)
                }
            })
        },


        Switch_multi(value, device_info) {
            console.log("-------")
            let info = 0
            info = this.light_1 + this.light_2 + this.light_3 + this.light_4
            console.log(info)
            this.switch_light(device_info.device.id, info, device_info.index)
        },

        switch_single(id, type, state, index) {
            let info = 0
            if (type == 'multi') {
                if (state) {
                    info = 15
                }
            } else {
                if (state) {
                    info = 1
                }
            }
            this.switch_light(id, info, index)
        },
        /**
         * 开关控制
         * @param id
         * @param state
         * @param index
         */
        switch_light(id, info, index) {

            console.log(info)
            this.request.get("/devices/Switch_more", {
                params: {
                    id: id,
                    info: info
                }
            }).then(res => {
                console.log(res)
                let that = this
                let point = {deviceId: id}
                if (JSON.parse(res.data).code != '1026') {
                    this.$message.success(JSON.parse(res.data).msg)
                    let loading = this.$loading({
                        text: "请求最新灯况，请稍后",
                        lock: true,
                        duration: 3000
                    });
                    setTimeout(function () { //3秒后更新设备信息
                        that.location(point, index)
                        loading.close()
                    }, 3000);
                } else {
                    this.$message.error(JSON.parse(res.data).msg)
                    that.location(point, index)
                }
            })
        },

        get_switch() {
            this.request.get("/devices/getSwitch", {
                params: {
                    pid: this.project.id
                }
            }).then(res => {
                console.log(res)
                this.switchList = res.data
                this.switchName = '添加'
               /* for (var i = 0; i < res.data.length; i++) {

                    if (res.data[i].id == this.device.switchId) {
                        console.log("有漏保：：：：：" + res.data[i].nickName)
                        this.switchName = res.data[i].nickName
                    }
                    this.switchActionSheet.push("漏保开关" + (i + 1) + ":" + res.data[i].nickName)
                }
                if (this.switchName != '点击添加') {
                    this.switchActionSheet.push("刪除綁定")
                }*/
            }).catch(() => {

            });

        },
        beforeHandleCommand(index,device_index){
            return {
                'index': index,
                'device_index':device_index
            }
        },
        handleCommand(command) {
            console.log(command)
            /*console.log(this.switchList[command.index])
            console.log(command.index)
            console.log(command.command)*/
            if(this.device_info.device.switchId != this.switchList[command.index].id){//判断当前选中的漏保开关是否是已经绑定的
                this.change_banding_switch(this.switchList[command.index].id,command.device_index)
            }

        },
        reboot(id) {
            this.$confirm('是否重启该设备?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.request.get("/devices/Reboot", {
                    params: {
                        id: id,
                    }
                }).then(res => {
                    console.log(res)
                    // this.$message.success(JSON.parse(res.data).msg)

                    let that = this
                    if (JSON.parse(res.data).code != '1026') {
                        this.$message.success(JSON.parse(res.data).msg)

                        let loading = this.$loading({
                            text: "请求最新灯况，请稍后",
                            lock: true,
                            duration: 5000
                        });

                        setTimeout(function () { //3秒后更新设备信息
                            let point = {deviceId: id}
                            that.location(point, index)
                            loading.close()
                        }, 5000);
                    } else {

                        this.$message.error(JSON.parse(res.data).msg)
                    }
                })
            }).catch(() => {

            });

        },
        radio_change() {

            console.log(this.deviceForm.type);
        },
        getTypeName(str) {
            let name = ""
            switch (str) {
                case 'light':
                    name = "单灯"
                    break;
                case 'multi':
                    name = "多头灯具"
                    break;
                case 'switch':
                    name = "漏保开关"
                    break;
            }
            return name;
        },
        getdate(str) {

            var now = new Date(str),
                y = now.getFullYear(),
                m = now.getMonth() + 1,
                d = now.getDate();
            return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
        },
        getDiffDay(date_1, date_2) {
            // 计算两个日期之间的差值
            let totalDays, diffDate
            let myDate_1 = Date.parse(date_1)
            let myDate_2 = Date.parse(date_2)
            // 将两个日期都转换为毫秒格式，然后做差
            diffDate = Math.abs(myDate_1 - myDate_2) // 取相差毫秒数的绝对值

            totalDays = Math.floor(diffDate / (1000 * 3600 * 24)) // 向下取整
            // console.log(totalDays)

            return totalDays == 0 ? '1' : totalDays // 相差的天数
        },
        dateFormat(fmt, date) {
            let ret;
            const opt = {
                "Y+": date.getFullYear().toString(), // 年
                "m+": (date.getMonth() + 1).toString(), // 月
                "d+": date.getDate().toString(), // 日
                "H+": date.getHours().toString(), // 时
                "M+": date.getMinutes().toString(), // 分
                "S+": date.getSeconds().toString() // 秒
                // 有其他格式化字符需求可以继续添加，必须转化成字符串
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                }
                ;
            }
            ;
            return fmt;
        },
    }


}
</script>
<style scoped>
/*@import '../style/amap.css';*/
/*.home_div {
    padding: 0px;
    margin: 0px;
    width: 60%;
    height: 60%;
    position: relative;
}*/

/*#container {*/
/*    padding: 0px;*/
/*    margin: 0px;*/
/*    width: 100%;*/

/*    position: absolute;*/
/*}*/
.info {
    z-index: 99;
    padding: .75rem 1.25rem;
    /*    margin-bottom: 1rem;*/
    border-radius: .25rem;
    position: fixed;
    top: calc(100vh - 500px);
    background-color: white;
    width: auto;
    min-width: 22rem;
    border-width: 0;
    right: 1rem;
    box-shadow: 0 2px 6px 0 rgba(114, 124, 245, .5);
}

.info2 {
    z-index: 99;
    padding: .75rem 1.25rem;
    /*    margin-bottom: 1rem;*/
    border-radius: .25rem;
    position: fixed;
    bottom: 250px;
    background-color: white;
    width: auto;
    min-width: 22rem;
    border-width: 0;
    right: 1rem;
    box-shadow: 0 2px 6px 0 rgba(114, 124, 245, .5);
}

.map_title {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 50px;
    background-color: rgba(27, 25, 27, 0.884);

}

h3 {
    position: absolute;
    left: 10px;
    z-index: 2;
    color: white;
}
</style>
